'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { Tab as RAC_Tab, TabList as RAC_TabList, TabPanel as RAC_TabPanel, Tabs as RAC_Tabs } from 'react-aria-components';
import { Stack } from '~/components/Layout/Stack';
import styles from './Tabs.module.css';
import type { TabContentProps, TabLabelProps, TabsListProps, TabsProps } from './Tabs.types';
const TabsContainer = t0 => {
  const $ = _c(12);
  let children;
  let onSelectionChange;
  let props;
  let selectedKey;
  if ($[0] !== t0) {
    ({
      children,
      selectedKey,
      onSelectionChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = onSelectionChange;
    $[3] = props;
    $[4] = selectedKey;
  } else {
    children = $[1];
    onSelectionChange = $[2];
    props = $[3];
    selectedKey = $[4];
  }
  let t1;
  if ($[5] !== children) {
    t1 = <Stack space="--by-space-600">{children}</Stack>;
    $[5] = children;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== onSelectionChange || $[8] !== props || $[9] !== selectedKey || $[10] !== t1) {
    t2 = <RAC_Tabs data-test-id="Tabs" className={styles.tabsContainer} selectedKey={selectedKey} onSelectionChange={onSelectionChange} {...props}>{t1}</RAC_Tabs>;
    $[7] = onSelectionChange;
    $[8] = props;
    $[9] = selectedKey;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
const TabsList = t0 => {
  const $ = _c(7);
  const {
    ariaLabel,
    children,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const t2 = variant === "default";
  const t3 = variant === "minimal";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = clsx({
      [styles.tabsList]: t2,
      [styles.tabsListMinimal]: t3
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== ariaLabel || $[4] !== children || $[5] !== t4) {
    t5 = <RAC_TabList aria-label={ariaLabel} className={t4}>{children}</RAC_TabList>;
    $[3] = ariaLabel;
    $[4] = children;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
const Tab = t0 => {
  const $ = _c(7);
  const {
    id,
    children,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const t2 = variant === "default";
  const t3 = variant === "minimal";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = clsx({
      [styles.tab]: t2,
      [styles.tabMinimal]: t3
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== id || $[5] !== t4) {
    t5 = <RAC_Tab id={id} className={t4}>{children}</RAC_Tab>;
    $[3] = children;
    $[4] = id;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
const TabContent = t0 => {
  const $ = _c(3);
  const {
    id,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== id) {
    t1 = <RAC_TabPanel id={id} className={styles.tabPanel}>{children}</RAC_TabPanel>;
    $[0] = children;
    $[1] = id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export { TabsContainer, TabsList, Tab, TabContent };